// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__L_RH5","image":"loader_image__USXs3","title":"loader_title__zrZPd","sub_title":"loader_sub_title__j2WN8","button":"loader_button__Xf_1I"};